<template>
  <h1>お申し込み完了</h1>
  <div class="honnbunn">
    <p>{{ serviceTitle }}</p>
  </div>
  <hr class="yokosenn" />
  <!--受付完了の内容-->
  <div class="kannryou">
    <p>
      受付完了しました。<br />
      詳細はご登録いただいているメールアドレスへお送りします。<br />
      メールが受信できていることをご確認ください。<br />
      <br />
      左上の「×」からアプリへお戻りください。
    </p>
  </div>
  <br />
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "registration-confirmation",
  components: {},
  data() {
    return {
      gaType: "gaEvent",
      gaAction: "gaSoEvent",
      screenName: "complete",
    };
  },
  computed: {
    ...mapState(["serviceTitle"]),
    serviceName() {
      return this.$store.state.formData.serviceName;
    },
  },
  mounted() {
    document.title = "お申し込み完了画面";
    this.sendGaEvent("display", "0");

    this.serviceTitle = this.$store.state.serviceTitle;
  },
  methods: {
    // GAへのイベント送信処理
    sendGaEvent(action, time) {
      try {
        if (!window.ReactNativeWebView) {
          return;
        }
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: this.gaType,
            content: {
              action: this.gaAction,
              args: [
                {
                  service_name: this.serviceName,
                  screen_name: this.screenName,
                  action: action,
                  time: time,
                },
              ],
            },
          }),
        );
      } catch (e) {
        //alert(e); イベント送信がエラーでも申込は続けられるようにする
      }
    },
  },
};
</script>

<style src="./dx-shukkinbo-complete.css"></style>
